module.exports = function(str) {

  var pagetop = $(str);

  pagetop.on('click', function() {
    // $('html,body').animate({
    //   scrollTop: '0'
    // }, 1000, 'easeOutExpo');
    TweenMax.to(window, 1, {scrollTo: {y:0}, ease:Power4.easeOut});
  });
};



//////////////////
// WEBPACK FOOTER
// ./src/js/pagetop.js
// module id = 11
// module chunks = 0